<div class="cd-fake-tabs">
  @if (options.length > 0) { @for (item of options; track item; let i = $index) {
  <div (click)="onChange(i)" class="item" [ngClass]="i === selectedIndex ? 'selected' : ''">
    <span class="cds-body1-demibold">
      {{ item }}
    </span>
  </div>
  } } @if (optionsObj.length > 0) { @for (item of optionsObj; track item) {
  <div (click)="onChangeObjValue(item.value)" class="item" [ngClass]="{ selected: selectedValue === item.value }">
    <span class="cds-detail2-demibold">{{ item.label }}</span>
  </div>
  } }
</div>
